export default "__VITE_ASSET__rXI$McJR__"